// T114 (3 Nov 2026) — pesan pendaftaran Telegram siap kirim lewat WhatsApp: tautan (sekali ketuk) + cadangan
// "/daftar <kode>" bila bot membalas petunjuk "/start" polos. Dipakai layar Personil dan HRD Karyawan supaya isinya
// satu. Kodenya diterbitkan backend (`perintah_cadangan`), layar hanya menyusunnya jadi kalimat.

/** Satu pesan utuh untuk disalin ke WhatsApp orangnya. `perintah` boleh kosong (server lama). */
export function pesanPendaftaranTelegram({ url, perintah, jam }) {
  const baris = [
    "Pendaftaran tugas ETAMS lewat Telegram:",
    `1. Ketuk tautan ini dari HP yang memakai Telegram, lalu tekan START: ${url}`,
  ];
  if (perintah) {
    baris.push(`2. Bila bot membalas "buka tautan pendaftaran", salin baris di bawah ini dan kirim ke bot:`);
    baris.push(perintah);
  }
  if (jam) baris.push(`Berlaku ${jam} jam.`);
  return baris.join("\n");
}
